'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var reactIntersectionObserver = require('react-intersection-observer');
var nthHookTheme = require('@narvar/nth-hook-theme');
var ViewportConfigProvider = require('../../providers/ViewportConfigProvider.js');
var theme = require('../../consts/theme.js');
var StickyFooter_module = require('./StickyFooter.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const StickyFooter = _ref => {
  var _viewportConfig$ancho, _viewportConfig$ancho2, _viewportConfig$ancho3;
  let {
    absolute,
    fixed,
    removePadding,
    onShow,
    children
  } = _ref;
  const {
    panelcontainerNoneNone,
    documentbodyNoneNone
  } = nthHookTheme.useTheme();
  const viewportConfig = ViewportConfigProvider.useViewportConfig();
  const {
    ref,
    inView
  } = reactIntersectionObserver.useInView({
    threshold: 0
  });
  const inline = inView && !fixed && !absolute;
  React.useEffect(() => {
    onShow === null || onShow === void 0 ? void 0 : onShow({
      inView,
      display: inline ? 'inline' : 'footer'
    });
  }, [inView, inline, onShow]);
  const footerWrapperClasses = clsx__default["default"]({
    [StickyFooter_module["default"].footerWrapper]: true,
    [StickyFooter_module["default"].footerWrapperNoPadding]: removePadding === 'always' || removePadding === 'inline' && inline || removePadding === 'footer' && !inline
  });
  const footerStyles = {
    zIndex: theme.zIndex.AppBar,
    bottom: `${((_viewportConfig$ancho = viewportConfig.anchor) === null || _viewportConfig$ancho === void 0 ? void 0 : _viewportConfig$ancho.offsetBottom) ?? 0}px`,
    left: `${((_viewportConfig$ancho2 = viewportConfig.anchor) === null || _viewportConfig$ancho2 === void 0 ? void 0 : _viewportConfig$ancho2.offsetLeft) ?? 0}px`,
    right: `${((_viewportConfig$ancho3 = viewportConfig.anchor) === null || _viewportConfig$ancho3 === void 0 ? void 0 : _viewportConfig$ancho3.offsetRight) ?? 0}px`,
    ...documentbodyNoneNone,
    backgroundColor: (documentbodyNoneNone === null || documentbodyNoneNone === void 0 ? void 0 : documentbodyNoneNone.backgroundColor) ?? '#fff',
    borderTopColor: (panelcontainerNoneNone === null || panelcontainerNoneNone === void 0 ? void 0 : panelcontainerNoneNone.borderTopColor) || '#ccc',
    borderTopWidth: (panelcontainerNoneNone === null || panelcontainerNoneNone === void 0 ? void 0 : panelcontainerNoneNone.borderTopWidth) || '1px',
    borderTopStyle: (panelcontainerNoneNone === null || panelcontainerNoneNone === void 0 ? void 0 : panelcontainerNoneNone.borderTopStyle) || 'solid'
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: footerWrapperClasses,
    ref: ref
  }, inline && /*#__PURE__*/React__default["default"].createElement("div", null, children), absolute && /*#__PURE__*/React__default["default"].createElement("div", {
    className: StickyFooter_module["default"].absoluteContainer,
    style: footerStyles
  }, children), !inline && !absolute && /*#__PURE__*/React__default["default"].createElement("div", {
    className: StickyFooter_module["default"].stickyContainer,
    style: {
      ...footerStyles
    }
  }, children));
};
var StickyFooter$1 = nthHookTheme.withThemeProvider(StickyFooter, {
  themeTokens: ['documentbodyNoneNone', 'panelcontainerNoneNone']
});

exports["default"] = StickyFooter$1;
